<template>
    <v-container>
        <h1>Help</h1>
        <p>More coming soon.</p>
        <p>In the meantime, you can email <a href="mailto:support@razayya.com">Razayya Support</a></p>
    </v-container>
</template>